<template>
    <div class="resource__files">
        <div class="resource__files__container display--flex">
            <div v-if="showUploadButton" class="resource__files__input display--flex">
                <label for="resource" class="pointer display--flex">
                    <icon-clip/>
                    <span class="capitalize color--green">  {{ $t( 'global.attachFile' ) }} </span>
                </label>
                <input
                    id="resource"
                    name="resource"
                    type="file"
                    ref="fileRef"
                    class="input--file"
                    :value="inputValue"
                    hidden
                    @change="processFile($event)"
                >
            </div>
            <div v-for="( file, index) in files" :key="index" class="resource__files__file position--relative">
                {{ file.name }}
                <span @click="removeFile( file )" class="resource__files__remove pointer"></span>
            </div>
        </div>
        <div
            v-if="showError"
            class="resource__files__error errors__message capitalize"
        >
            {{  $t( 'error.invalidFormat' ) }}
        </div>
    </div>
</template>
<script>
// imports
import {
    toRefs,
    reactive,
    computed,
    watch,
    ref
} from '@vue/composition-api';

// store
import { mapState, useActions } from '@/hooks/use-store';

export default {
    components: {
        IconClip: () => import( /* webpackChunkName: 'IconClip' */ '@/components/bundles/layout/images/icons/IconClip' )
    },
    props: {
        formatsAllowed: {
            type: Array,
            default: () => [
                '.jpeg',
                '.jpg',
                '.bmp',
                '.png',
                '.pdf',
                '.xlsx',
                '.csv',
                '.webp',
                '.gif',
                '.doc',
                '.txt',
                '.ppt',
                '.odt',
                '.xls',
                '.psd',
                '.mp3',
                '.m4a',
                '.ogg',
                '.wav',
                '.mp4',
                '.mov',
                '.avi',
                '.mpg',
                '.ogv',
                '.3gp',
                '.3g2',
                '.zip',
                '.svg'
            ]
        },
        multipleFiles: {
            type: Boolean,
            default: false
        },
        name: String
    },
    setup ( props, { emit }) {
        const { actions } = useActions(); // Obter actions.
        const payload = mapState({ module: 'storePayload', key: 'payload' });
        const update = mapState({ module: 'storePayload', key: 'update' });
        const fileRef = ref( null );

        // Criação das opções dos campos com drops.
        const state = reactive({
            files: [],
            showError: false,
            formats: {
                allowed: props.formatsAllowed,
                errorText: props.formatsAllowed.join( ', ' )
            },
            inputValue: ''
        });

        // validar ficheiro
        // eslint-disable-next-line
        const fileFormatValidation = ( formats, fileName ) => ( new RegExp( '(' + formats.join('|').replace(/\./g, '\\.') + ')$' ) ).test( fileName );

        const showUploadButton = computed( () => props.multipleFiles || ( !props.multipleFiles && state.files?.length <= 0 ) );

        // Selecionar ficheiro
        const processFile = event => {
            state.showError = false;
            const file = event.target.files[0];

            if ( !props.multipleFiles )
                state.files = [];

            ( fileFormatValidation( state.formats.allowed, file.name ) )
                ? state.files.push( file )
                : state.showError = true;

            emit( 'input', state.files );
        };

        // remover file do payload
        const removeFile = file => {
            state.inputValue = '';
            let i = -1;
            state.files.forEach( element => {
                i++;
                if ( element === file ) {
                    state.files.splice( i, 1 );
                    actions( 'registerField', { name: props.name, value: state.files });
                }
            });
        };

        // limpar campo do payload caso o mesmo se encontre vazio
        watch( () => payload.value[props.name],
            newResources => {
                if ( !newResources?.length )
                    actions( 'deleteField', { name: props.name });
            });

        // limpar os files quando existir uma submissão de formulário.
        watch( () => update.value,
            newUpdate => {
                if ( newUpdate )
                    state.files = [];
            });

        return {
            ...toRefs( state ),
            processFile,
            removeFile,
            fileRef,
            showUploadButton
        };
    }
};
</script>
<style lang="scss">
    .resource{
        &__files {
            flex-wrap: wrap;
            align-items: flex-start;
            &__file {
                @include rounded-corner( 5px );
                @include  element-border( $color-green );
                @include elements-colors ( none, $color-green );
                @include typography-specs( 14px, unset );
                @include sentence-cut();
                padding: 5px 33px 5px 5px;
            }
            &__remove{
                position: absolute;
                right: 5px;
                top: 11px;
                width: 32px;
                &:before, &:after {
                    position: absolute;
                    right: 11px;
                    content: ' ';
                    height: 15px;
                    width: 2px;
                    background-color: $color-green;
                }
                &:before {
                    transform: rotate(45deg);
                }
                &:after {
                    transform: rotate(-45deg);
                }
            }
            &__error{
                color: $color-red;
                @include typography-specs( 12px, unset );
                text-align: center;
                margin-top: 10px;
            }
            &__container {
                flex-wrap: wrap;
                gap: 10px;
                margin-top: 10px;
            }
            label{
                align-items: center;
                gap: 5px;
                span{
                    @include typography-specs( 15px, 20px, 400 );
                    margin-left: 5px;
                }
            }
        }
    }
</style>